import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/app/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { trackPageview } from "@/lib/analytics";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Disclaimer from "@/pages/Disclaimer";
import AcceptableUse from "@/pages/AcceptableUse";
import SubscriptionPolicy from "@/pages/SubscriptionPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Contact from "@/pages/Contact";
import PublicPricing from "@/pages/PublicPricing";
import Dashboard from "@/pages/Dashboard";
import NewAssessment from "@/pages/NewAssessment";
import Result from "@/pages/Result";
import History from "@/pages/History";
import Properties from "@/pages/Properties";
import Pricing from "@/pages/Pricing";
import Billing from "@/pages/Billing";
import AdminDashboard from "@/pages/AdminDashboard";
import Settings from "@/pages/Settings";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminNotifications from "@/pages/AdminNotifications";
import AdminContent from "@/pages/AdminContent";
import EvidenceCentre from "@/pages/EvidenceCentre";
import Portfolio from "@/pages/Portfolio";
import Team from "@/pages/Team";
import AcceptInvite from "@/pages/AcceptInvite";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/pricing" element={<PublicPricing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/acceptable-use" element={<AcceptableUse />} />
            <Route path="/subscription-policy" element={<SubscriptionPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/checkout/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />

            <Route path="/app/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/app/new" element={<ProtectedRoute><NewAssessment /></ProtectedRoute>} />
            <Route path="/app/result/:id" element={<ProtectedRoute><Result /></ProtectedRoute>} />
            <Route path="/app/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
            <Route path="/app/evidence" element={<ProtectedRoute><EvidenceCentre /></ProtectedRoute>} />
            <Route path="/app/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
            <Route path="/app/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
            <Route path="/app/properties" element={<ProtectedRoute><Properties /></ProtectedRoute>} />
            <Route path="/app/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
            <Route path="/app/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/app/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/app/admin/notifications" element={<ProtectedRoute><AdminNotifications /></ProtectedRoute>} />
            <Route path="/app/admin/content" element={<ProtectedRoute><AdminContent /></ProtectedRoute>} />
            <Route path="/app/admin/analytics" element={<ProtectedRoute><AdminAnalytics /></ProtectedRoute>} />
            <Route path="/app/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
